/* Xclusive Nova design kit behaviour. Shared by the Shopify sections and the preview.
   Uses event delegation on document, so it keeps working when sections re-render
   (Shopify theme editor, or the preview's page switching). */
(function () {
  if (window.XN) return;

  const XN = (window.XN = {});
  try { XN.appliedCode = sessionStorage.getItem('xn-code') || undefined; } catch (e) {}

  /* ---------- Product: colour, size, variant, waitlist ---------- */
  function productState(root) {
    if (!root._xn) {
      const data = JSON.parse(root.querySelector('script[data-xn-variants]').textContent);
      root._xn = { variants: data, colour: null, size: null };
      const firstAvail = data.find(v => v.available) || data[0];
      root._xn.colour = firstAvail.colour || null;
    }
    return root._xn;
  }

  function sameText(a, b) {
    return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();
  }

  XN.syncProduct = function (root) {
    const st = productState(root);
    const inColour = st.variants.filter(v => !st.colour || sameText(v.colour, st.colour));

    // Swatches
    root.querySelectorAll('[data-xn-colour]').forEach(b => {
      b.setAttribute('aria-pressed', sameText(b.dataset.xnColour, st.colour) ? 'true' : 'false');
      const out = st.variants.filter(v => sameText(v.colour, b.dataset.xnColour)).every(v => !v.available);
      b.classList.toggle('is-out', out);
      b.setAttribute('aria-label', b.dataset.xnColour + (out ? ', sold out' : ''));
    });
    const colourName = root.querySelector('[data-xn-colour-name]');
    if (colourName) colourName.textContent = st.colour || '';

    // Gallery: show only photos tagged with the chosen colour (alt text), plus untagged ones
    const figs = [...root.querySelectorAll('[data-xn-media]')];
    const tagged = figs.some(f => f.dataset.xnMedia && sameText(f.dataset.xnMedia, st.colour));
    figs.forEach(f => {
      const tag = f.dataset.xnMedia;
      f.hidden = tagged && tag !== '' && !sameText(tag, st.colour);
    });
    XN.syncDots(root);

    // Sizes
    root.querySelectorAll('[data-xn-size]').forEach(b => {
      const v = inColour.find(x => sameText(x.size, b.dataset.xnSize));
      const out = !v || !v.available;
      b.classList.toggle('is-out', out);
      b.setAttribute('aria-pressed', sameText(b.dataset.xnSize, st.size) ? 'true' : 'false');
      const small = b.querySelector('small');
      const chosen = sameText(b.dataset.xnSize, st.size);
      if (small) small.textContent = out ? (chosen ? 'Waitlist' : 'Sold out') : '';
      b.setAttribute('aria-label', b.dataset.xnSize + (out ? ', sold out, join the waitlist' : ''));
    });

    // Variant + CTA + waitlist
    const chosen = st.size ? inColour.find(v => sameText(v.size, st.size)) : null;
    const idInput = root.querySelector('input[name="id"]');
    if (idInput && chosen) idInput.value = chosen.id;
    const cta = root.querySelector('[data-xn-cta]');
    const wait = root.querySelector('[data-xn-waitlist]');
    const allOut = inColour.every(v => !v.available);
    const showWait = (chosen && !chosen.available) || (!st.size && allOut);
    if (wait) {
      wait.hidden = !showWait;
      const what = wait.querySelector('[data-xn-wait-what]');
      if (what) what.textContent = [st.colour, chosen ? chosen.size : ''].filter(Boolean).join(', ');
    }
    if (cta) {
      cta.hidden = showWait;
      cta.disabled = !chosen;
      cta.textContent = chosen ? 'Add to cart' : 'Select a size';
    }
  };

  XN.syncDots = function (root) {
    const gal = root.querySelector('[data-xn-gallery]');
    const dots = root.querySelector('[data-xn-dots]');
    if (!gal || !dots) return;
    const visible = [...gal.querySelectorAll('[data-xn-media]')].filter(f => !f.hidden);
    dots.innerHTML = visible.map((_, i) => `<span class="${i === 0 ? 'is-on' : ''}"></span>`).join('');
    gal.scrollLeft = 0;
  };

  document.addEventListener('click', e => {
    const sw = e.target.closest('[data-xn-colour]');
    if (sw) {
      const root = sw.closest('[data-xn-product]');
      productState(root).colour = sw.dataset.xnColour;
      XN.syncProduct(root);
      root.dispatchEvent(new CustomEvent('xn:colour', { bubbles: true, detail: sw.dataset.xnColour }));
      return;
    }
    const sz = e.target.closest('[data-xn-size]');
    if (sz) {
      const root = sz.closest('[data-xn-product]');
      productState(root).size = sz.dataset.xnSize;
      XN.syncProduct(root);
      return;
    }
    const menuOpen = e.target.closest('[data-xn-menu-open]');
    if (menuOpen) { XN.menu(true); return; }
    const menuClose = e.target.closest('[data-xn-menu-close], [data-xn-menu] a');
    if (menuClose) XN.menu(false, !menuClose.matches('a'));
  });

  // Mobile gallery dots follow the swipe
  document.addEventListener('scroll', e => {
    const gal = e.target.closest && e.target.closest('[data-xn-gallery]');
    if (!gal) return;
    const root = gal.closest('[data-xn-product]');
    const dots = root && root.querySelectorAll('[data-xn-dots] span');
    if (!dots || !dots.length) return;
    const i = Math.round(gal.scrollLeft / gal.clientWidth);
    dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
  }, true);

  /* ---------- Menu: disclosure pattern, focus in, Esc out, focus back ---------- */
  XN.menu = function (open, restoreFocus = true) {
    const m = document.querySelector('[data-xn-menu]');
    const btn = document.querySelector('[data-xn-menu-open]');
    if (!m) return;
    m.hidden = !open;
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) { const first = m.querySelector('a, button'); if (first) first.focus(); }
    else if (restoreFocus && btn) btn.focus();
  };
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { const m = document.querySelector('[data-xn-menu]'); if (m && !m.hidden) XN.menu(false); }
  });

  /* ---------- Waitlist: quiet confirmation ---------- */
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-xn-wait-form], [data-xn-news-form]');
    if (!f || f.dataset.xnLive === 'true') return;
    e.preventDefault();
    const msg = f.querySelector('[data-xn-thanks]');
    if (msg) { msg.hidden = false; }
    const field = f.querySelector('.xn-field');
    if (field) field.hidden = true;
  });

  /* ---------- Index of names: hover shows the dress ---------- */
  document.addEventListener('mouseover', e => {
    const a = e.target.closest('[data-xn-peek]');
    if (!a) return;
    const box = a.closest('[data-xn-names]');
    const img = box && box.querySelector('[data-xn-peek-img]');
    if (img && img.getAttribute('src') !== a.dataset.xnPeek) {
      img.style.opacity = 0;
      setTimeout(() => { img.src = a.dataset.xnPeek; img.style.opacity = 1; }, 160);
    }
  });

  /* ---------- Announcement bar rotation ---------- */
  XN.rotate = function () {
    document.querySelectorAll('[data-xn-announce]').forEach(bar => {
      if (bar._xnTimer) return;
      const items = [...bar.querySelectorAll('span')];
      if (items.length < 2) return;
      let i = 0;
      items.forEach((s, n) => (s.hidden = n !== 0));
      bar._xnTimer = setInterval(() => {
        items[i].hidden = true;
        i = (i + 1) % items.length;
        items[i].hidden = false;
      }, 4500);
    });
  };

  /* ---------- Email sign-up drop-down: once per visitor, after a delay or a third of the page ---------- */
  const KEY = 'xn-signup-seen-2';
  const seen = () => { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
  const remember = () => { try { localStorage.setItem(KEY, '1'); } catch (e) {} };
  const isPhone = () => window.matchMedia('(max-width: 700px)').matches;
  XN.pageView = function () {
    try { const n = (parseInt(sessionStorage.getItem('xn-pv'), 10) || 0) + 1; sessionStorage.setItem('xn-pv', n); return n; } catch (e) { return 1; }
  };
  XN.signup = function () {
    const box = document.querySelector('[data-xn-signup]');
    if (!box || seen()) return;
    if (box._xnTimer) clearTimeout(box._xnTimer);
    // Count time on the site, not per page, so it fires once after 30 seconds of browsing.
    let start = Date.now();
    try { start = parseInt(sessionStorage.getItem('xn-start'), 10) || Date.now(); sessionStorage.setItem('xn-start', start); } catch (e) {}
    const wait = Math.max(0, (parseInt(box.dataset.delay, 10) || 30) * 1000 - (Date.now() - start));
    box._xnTimer = setTimeout(() => { if (!seen()) { box.hidden = false; remember(); } }, wait);
  };
  document.addEventListener('click', e => {
    if (e.target.closest('[data-xn-signup-close]') || e.target.matches('[data-xn-signup]')) { const b = document.querySelector('[data-xn-signup]'); if (b) b.hidden = true; remember(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { const b = document.querySelector('[data-xn-signup]'); if (b) b.hidden = true; } });
  // After joining: show the code, apply it to the checkout, keep the email as the backup copy.
  XN.signupDone = function (box) {
    if (!box) return;
    const code = box.dataset.code;
    const form = box.querySelector('[data-xn-signup-form]'); if (form) form.hidden = true;
    const done = box.querySelector('[data-xn-signup-done]'); if (done) done.hidden = false;
    const fine = box.querySelector('[data-xn-signup-fine]'); if (fine) fine.hidden = true;
    remember();
    if (code) {
      XN.appliedCode = code;
      try { sessionStorage.setItem('xn-code', code); } catch (e) {}
      // Shopify: visiting /discount/CODE stores the code for this shopper's checkout.
      if (window.Shopify && window.fetch) fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(() => {});
    }
  };
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-xn-signup-form]');
    if (!f || f.dataset.xnLive === 'true') return;
    e.preventDefault();
    XN.signupDone(f.closest('[data-xn-signup]'));
  });
  document.addEventListener('click', e => {
    const c = e.target.closest('[data-xn-copy]');
    if (!c) return;
    const text = c.parentElement.querySelector('[data-xn-code-text]').textContent;
    const ok = () => { c.textContent = 'Copied'; setTimeout(() => (c.textContent = 'Copy'), 1800); };
    if (navigator.clipboard) navigator.clipboard.writeText(text).then(ok).catch(() => {}); 
  });

  XN.init = function (scope) {
    (scope || document).querySelectorAll('[data-xn-product]').forEach(r => { r._xn = null; XN.syncProduct(r); });
    XN.rotate();
    XN.signup();
    const flag = document.querySelector('[data-xn-signup] [data-xn-posted]');
    if (flag) { const box = flag.closest('[data-xn-signup]'); box.hidden = false; XN.signupDone(box); }
  };

  if (document.readyState !== 'loading') XN.init();
  else document.addEventListener('DOMContentLoaded', () => XN.init());
  document.addEventListener('shopify:section:load', e => XN.init(e.target));
})();
